<template>
  <div class="bjtjfx-container">
    <el-row class="tcf-row">
      <el-col class="card">
        <div class="card-body">
          <el-form :inline="true" size="small" :model="searchForm" @submit.native.prevent>
            <el-form-item label="过预付款日期">
              <el-date-picker v-model="searchForm.time" format="yyyy年MM月dd日" value-format="yyyy-MM-dd" type="daterange"
                :clearable="false" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="组织">
              <el-select v-model="searchForm.group" style="width: 120px" @keyup.enter.native="Search" filterable>
                <el-option v-for="item in groupList" :key="item.groupid" :label="item.group_name"
                  :value="item.groupid" />
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button icon="el-icon-search" @click="getData">搜索</el-button>
              <el-button icon="el-icon-printer" style="margin-left: 10px;" size="small" :loading="excelLoading"
                @click="exportExcel">导出Excel</el-button>
              <el-button icon="el-icon-printer" style="margin-left: 10px;" size="small" :loading="excelDetailLoading"
                @click="exportExcelDetail">导出明细</el-button>
            </el-form-item>
          </el-form>

          <div class="card-content">
            <el-row :gutter="20" style="padding-top: 20px">
              <el-col :span="24">
                <div style="font-size: 16px; font-weight: bold; padding: 4px 0;">
                  经销商业绩总金额：共 <span style="color: #F56C6C;">{{ tjfxData.totalVo ? tjfxData.totalVo.total : 0 }}</span> 元，
                  已完成订单总金额：共 <span style="color: #F56C6C;">{{ tjfxData.totalVo ? tjfxData.totalVo.totalPaid : 0 }}</span> 元，
                  过预付款订单总金额：共 <span style="color: #F56C6C;">{{ tjfxData.totalVo ? tjfxData.totalVo.totalAmount : 0 }}</span> 元
                </div>
              </el-col>

              <el-col :span="16" style="padding-top: 10px">
                <el-table :data="tjfxData.dealerAmountVo" v-loading="loading" stripe max-height="600px" style="width: 100%">
                  <el-table-column type="index" align="center" fixed="left" width="40"></el-table-column>
                  <el-table-column prop="dealerName" label="经销商" align="center" fixed="left" min-width="140" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="areaName" label="区域经理" align="center" min-width="80">
                  </el-table-column>
                  <el-table-column prop="serveName" label="客服" align="center" min-width="80">
                  </el-table-column>
                  <el-table-column prop="totalPaid" align="center" label="已完成订单金额">
                    <template #header>
                      已完成订单金额
                      <el-tooltip class="item" effect="dark" content="尾款已结清的订单中客户承担部分的金额" placement="top">
                        <i class="el-icon-info" style="font-size: 14px; color: #E6A23C;" />
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.totalPaid }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="totalAmount" align="center" label="过预付款订单金额">
                    <template #header>
                      过预付款订单金额
                      <el-tooltip class="item" effect="dark" content="已过预付款但尾款未结清的订单中客户承担部分的金额" placement="top">
                        <i class="el-icon-info" style="font-size: 14px; color: #E6A23C;" />
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.totalAmount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="total" align="center" label="总金额" width="90">
                    <template #header>
                      总金额
                      <el-tooltip class="item" effect="dark" content="总金额 = 已完成订单金额 + 过预付款订单金额" placement="top">
                        <i class="el-icon-info" style="font-size: 14px; color: #E6A23C;" />
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <span style="font-weight: 500;color:#409EFF">{{ scope.row.total }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="总金额占比" min-width="90">
                    <template slot-scope="scope">
                      <span>{{ scope.row.scaleTotal }}%</span>
                    </template>
                  </el-table-column>
                  <el-table-column align="center" label="操作" min-width="120">
                    <template slot-scope="scope">
                      <el-button icon="el-icon-search" @click="seeOrders(scope.row)" size="mini">查看详情</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-col>
              <el-col :span="8" v-if="chartOption.scale">
                <GraphicsChart id="scale" :option="chartOption.scale" />
              </el-col>
              <el-col :span="24" v-if="chartOption.amount" style="margin-top: 20px;">
                <GraphicsChart id="amount" :option="chartOption.amount" />
              </el-col>
            </el-row>
          </div>

        </div>
      </el-col>
    </el-row>

    <el-dialog :title="viewTitle" :visible.sync="orderVisible" width="85%" top="10vh"
      :destroy-on-close="true" :lock-scroll="true" :append-to-body="true">
      <div style="padding:10px 20px">
        <el-table
          :data="orderList"
          size="small"
          style="width: 100%;border:1px solid #EBEEF5;"
          height="65vh">
         <el-table-column
           label="订单号"
           min-width="120"
           align="center"
           show-overflow-tooltip>
           <template slot-scope="scope">
             <span style="font-weight: 500; color:#409EFF;cursor: pointer;text-decoration: underline;" @click="openDetails(scope.row)">
              {{scope.row.ordernum}}
             </span>
           </template>
         </el-table-column>
         <el-table-column
           prop="produnum"
           label="生产单号"
           align="center"
           min-width="100"
           show-overflow-tooltip>
         </el-table-column>
         <!-- <el-table-column prop="totalprice" label="总金额" align="center" min-width="100" /> -->
         <el-table-column prop="amount" label="实际金额" align="center" min-width="80">
           <template slot-scope="scope">
             <span style="font-weight: 500;color:#409EFF">{{ scope.row.amount }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="best" label="优惠金额" align="center" min-width="80" />
         <el-table-column prop="raise" label="加价" align="center" min-width="70" />
         <el-table-column prop="changes" label="更改单金额" align="center" min-width="90" />
         <el-table-column prop="clientcom" label="客户承担" align="center" min-width="80">
           <template slot-scope="scope">
             <span style="font-weight: 500;color:#409EFF">{{ scope.row.clientcom }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="designcom" label="设计承担" align="center" min-width="80" />
         <el-table-column prop="factorycom" label="工厂承担" align="center" min-width="80" />
         <el-table-column prop="paidfor" label="已付款金额" align="center" min-width="80">
           <template slot-scope="scope">
             <span style="font-weight: 500;color:#409EFF">{{ scope.row.paidfor }}</span>
           </template>
         </el-table-column>
         <el-table-column prop="refund" label="退款金额" align="center" min-width="80" />
         <el-table-column
           prop="subsistTime"
           label="过预付款时间"
           align="center"
           min-width="150">
         </el-table-column>
        </el-table>
      </div>
    </el-dialog>

  </div>
</template>

<script>
  import {
    getUser
  } from '@/utils/auth'

  import {
    getGroupInfoByUser,
    getYxtj2,
    excelYxtj2,
    excelYxtjDetail2,
  } from '@/api/erp'

  import {
    getGroupReport
  } from '@/api/pub'

  import GraphicsChart from '@/components/Charts/GraphicsChart'

  export default {
    name: 'jxsyjfx',
    components: {
      GraphicsChart
    },
    data() {
      return {
        loading: false,
        tjfxData: {},

        viewTitle: '',
        orderVisible: false,
        orderList: [],
        excelLoading: false,
        excelDetailLoading: false,

        searchForm: {
          search: '',
          group: null,
          time: []
        },
        groupList: [],
        group: {
          dBrand: 1
        },

        chartOption: {},
      }
    },
    computed: {
      user: getUser
    },
    created() {
      getGroupInfoByUser({
        groupid: this.user.dGroupid
      }).then(response => {
        this.group = response.data
      });

      this.searchForm.group = this.user.dGroupid
      this.searchForm.brand = this.searchForm.group == 1 ? '首造' : '乔金斯'
      this.getGroupList()

      const myDate = new Date()
      const year = myDate.getFullYear()
      let month = myDate.getMonth() + 1
      let day = myDate.getDate()
      month = month > 9 ? month + '' : '0' + month
      day = day > 9 ? day + '' : '0' + day
      this.searchForm.time.push(year + '-' + month + '-01')
      this.searchForm.time.push(year + '-' + month + '-' + day)

      this.getData()
    },
    methods: {
      getGroupList() {
        getGroupReport().then(response => {
          const arr = []
          for (const item of response.data) {
            if (item.nature === 0) {
              arr.push(item)
            }
          }
          this.groupList = arr
        })
      },

      getData() {
        if (this.loading) {
          this.$message({
            type: 'warning',
            message: '数据加载中'
          })
          return
        }
        let startTime = ''
        let endTime = ''
        if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
          startTime = this.searchForm.time[0]
          endTime = this.searchForm.time[1]
        }
        const data = {
          groupid: this.searchForm.group,
          start: startTime,
          end: endTime,
          userid: this.user.dUserid
        }
        this.loading = true
        getYxtj2(data).then(response => {
          const data = response.data || {}
          this.tjfxData = data

          if (Array.isArray(this.tjfxData.dealerAmountVo)) {
            this.tjfxData.dealerAmountVo.sort((a, b) => (b.total || 0) - (a.total || 0));
            const total = this.tjfxData.totalVo ? this.tjfxData.totalVo.total : 0
            this.tjfxData.dealerAmountVo.forEach(r => {
              r.name = r.dealerName
              r.scaleTotal = total > 0 ? Math.round((r.total || 0) / total * 10000) / 100 : 0
            });
          }
          this.initCharts(this.tjfxData.dealerAmountVo || [], 'scale')
          this.initCharts(this.tjfxData.dealerAmountVo || [], 'amount')

          this.loading = false
        }).catch(err => {
          this.loading = false
        })
      },

      initCharts(list, type) {
        if (type === 'amount') {
          let names = []
          let totalAmountArr = []
          let totalPaidArr = []
          let totalArr = []

          for (const item of list) {
            names.push(item.dealerName)
            totalAmountArr.push(item.totalAmount)
            totalPaidArr.push(item.totalPaid)
            totalArr.push(item.total)
          }

          let option = {
            lang: {
              printChart: '打印图表',
              downloadPNG: '下载JPEG 图片',
              downloadJPEG: '下载JPEG文档',
              downloadPDF: '下载PDF 图片',
              downloadSVG: '下载SVG 矢量图',
              contextButtonTitle: '下载图片'
            },
            chart: {
              type: 'column'
            },
            title: {
              text: '经销商业绩金额统计'
            },
            xAxis: {
              categories: [...names]
            },
            credits: {
              enabled: false
            },
            plotOptions: {
              column: {
                borderRadius: '2px'
              }
            },
            series: [{
              name: '已完成订单金额',
              data: [...totalPaidArr]
            }, {
              name: '过预付款订单金额',
              data: [...totalAmountArr]
            }, {
              name: '总金额',
              data: [...totalArr]
            }]
          }

          this.chartOption[`${type}`] = option
          return
        }

        let circleData = []

        for (const item of list) {
          circleData.push({
            name: item.name,
            y: item.scaleTotal
          })
        }

        const circle = {
          lang: {
            printChart: '打印图表',
            downloadPNG: '下载JPEG 图片',
            downloadJPEG: '下载JPEG文档',
            downloadPDF: '下载PDF 图片',
            downloadSVG: '下载SVG 矢量图',
            contextButtonTitle: '下载图片'
          },
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: '经销商业绩总金额占比',
          credits: {
            enabled: false
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.2f}%</b>'
          },
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              size: '120%', // 设置圆饼的大小
              dataLabels: {
                enabled: false, // 数据指引线
                format: '<b>{point.name}</b>: {point.percentage:.2f} %'
              },
              showInLegend: true, // 数据标签
            }
          },
          series: [{
            name: '占比',
            colorByPoint: true,
            data: circleData
          }]
        }

        if (type) {
          this.chartOption[`${type}`] = circle
        }
      },

      // 弹窗信息
      seeOrders(row) {
        this.orderVisible = true
        this.orderList = []
        if (Array.isArray(this.tjfxData.dealerAmountDetails)) {
          this.orderList = this.tjfxData.dealerAmountDetails.filter(r => r.dealerId == row.dealerId);
        }
        this.viewTitle = row.dealerName + ' - 订单列表 (共 ' + this.orderList.length + ' 单)'
      },
      openDetails(row) {
        if (row.orderId.length > 36) {
          this.$router.push({
            path: '/work/order/' + row.orderId.substring(0, 36),
            query: {
              data: row.orderId.substring(37)
            }
          })
        } else {
          this.$router.push({ path: '/work/order/' + row.orderId.substring(0, 36) })
        }
        this.orderVisible = false
      },

      exportExcel() {
        if (!this.excelLoading) {
          this.excelLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            groupid: this.searchForm.group,
            start: startTime,
            end: endTime,
            userid: this.user.dUserid
          }
          this.$message({
            message: '数据正在导出，请稍候'
          })
          excelYxtj2(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelLoading = false
          }).catch(() => {
            this.excelLoading = false
          })
        }
      },

      exportExcelDetail() {
        if (!this.excelDetailLoading) {
          this.excelDetailLoading = true
          let startTime = ''
          let endTime = ''
          if (this.searchForm.time !== null && this.searchForm.time.length === 2) {
            startTime = this.searchForm.time[0]
            endTime = this.searchForm.time[1]
          }
          const data = {
            groupid: this.searchForm.group,
            start: startTime,
            end: endTime,
            userid: this.user.dUserid
          }
          this.$message({
            message: '明细数据正在导出，请稍候'
          })
          excelYxtjDetail2(data).then(response => {
            const _this = this
            let xhr = new XMLHttpRequest()
            xhr.open('GET', response.data.dPath, true)
            xhr.responseType = 'blob'
            xhr.onload = function() {
              if (this.status === 200) {
                let blob = this.response
                let a = document.createElement('a')
                a.download = response.data.dName + '.' + response.data.dType
                a.href = window.URL.createObjectURL(blob)
                a.target = '_blank'
                a.click()
                const h = _this.$createElement
                _this.$msgbox({
                  title: '下载提示',
                  message: h('div', {
                    attrs: {
                      style: 'letter-spacing:1px;padding-left: 15px;line-height: 22px;'
                    }
                  }, [
                    h('span', null, `文件已下载，如文件未下载成功，请关闭相应浏览器拦截，`),
                    h('a', {
                      attrs: {
                        href: window.URL.createObjectURL(blob),
                        target: '_blank',
                        download: `${response.data.dName}.${response.data.dType}`,
                        style: 'color: #409EFF;text-decoration:underline;'
                      }
                    }, `点击这里`),
                    h('span', null, `重新下载。`)
                  ]),
                  showCancelButton: false,
                  confirmButtonText: '关闭',
                  beforeClose: (action, instance, done) => {
                    done()
                  }
                }).then(action => {})
              }
            }
            xhr.send()
            this.excelDetailLoading = false
          }).catch(() => {
            this.excelDetailLoading = false
          })
        }
      },

    }
  }
</script>

<style>
  .el-table .warning-row {
    background: #faecd8 !important;
  }

  .el-table .error-row {
    background: #fde2e2 !important;
  }

  .el-table .success-row {
    background: #e1f3d8 !important;
  }
</style>
